import React from 'react'
import { toTitleCase } from '@mobi/utils/string'
import type { FieldSummary } from '@core/Areas/RaceCardFixedOnly/Types/FieldSummary'
import {
  Proposition3FieldsStyled,
  PropositionStrongFieldsStyled,
  PropositionSummaryStyled,
  PropositionTrainerNameStyled,
  SelectionFormTableStyled,
} from '@core/Areas/RaceCardFixedOnly/RaceCardFixedOnly.styles'

type Props = {
  summary: FieldSummary
}

export const DogFieldSummary: React.FC<Props> = ({ summary }) => {
  if (!summary) return null

  return (
    <PropositionSummaryStyled>
      <SelectionFormTableStyled>
        <Proposition3FieldsStyled>
          <div>
            <PropositionStrongFieldsStyled>F:</PropositionStrongFieldsStyled>
            <span>{summary.lastFour}</span>
          </div>
        </Proposition3FieldsStyled>

        <PropositionTrainerNameStyled>
          <PropositionStrongFieldsStyled>T:</PropositionStrongFieldsStyled>
          <span>
            {summary.trainerName ? toTitleCase(summary.trainerName) : summary.trainerName}
          </span>
        </PropositionTrainerNameStyled>
      </SelectionFormTableStyled>
    </PropositionSummaryStyled>
  )
}
